import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Radio as RadioButton } from 'react-bootstrap';
import DateTimeField from '../../bootstrap-datetimepicker';
import DateUtils from '../../../utils/DateUtils';
import moment from 'moment';
import config from '../../../config';
import ValidationMessageConstants from '../../../constants/ValidationMessageConstants';
import StringConstants from '../../../constants/StringConstants';
import ValidationConfig from '../../../config/ValidationConfig';
import { MenuItem } from 'react-bootstrap';
import { Dropdown } from 'react-bootstrap';
import RegexUtils from '../../../utils/RegexUtils';
import { hasExceededYouthAccountPaymentLimit } from '../../../utils/AccountUtils';
class EditSOPayment extends React.Component {
  constructor(props) {
    super(props);
    this.showEndDate = this.showEndDate.bind(this);
    this.showHowMany = this.showHowMany.bind(this);
    this.repeatOptionChange = this.repeatOptionChange.bind(this);
    this.setReccuringData = this.setReccuringData.bind(this);
    this.onNoOfTimesChange = this.onNoOfTimesChange.bind(this);
    this.onEndDateChange = this.onEndDateChange.bind(this);
    this.editSOPayment = this.editSOPayment.bind(this);
    this.referenceChange = this.referenceChange.bind(this);
    this.onRefBlur = this.onRefBlur.bind(this);
    this.onNextDueChange = this.onNextDueChange.bind(this);
    this.validateNextDue = this.validateNextDue.bind(this);
    this.oftenChange = this.oftenChange.bind(this);
    this.amountChange = this.amountChange.bind(this);
    this.setHowOften = this.setHowOften.bind(this);
    this.updateFormValidation = this.updateFormValidation.bind(this);
    this.checkAllFields = this.checkAllFields.bind(this);
    this.checkOnBlurFeildValid = this.checkOnBlurFeildValid.bind(this);
    this.onblur = this.onblur.bind(this);
    this.endDateBlur = this.endDateBlur.bind(this);
    this.startDateBlur = this.startDateBlur.bind(this);
    const when = moment(
      DateUtils.getMomentFromDateString(this.props.activeData.when)
    ).format(config.dateFormatSlash);
    const minEndDateDiffrence =
      DateUtils.comapareFromCurrentDateSlashFormat(when);
    const maxDate = moment().add(1, 'years');
    this.state = {
      amount: parseFloat(this.props.activeData.amount).toFixed(2),
      reference: this.props.activeData.reference,
      when,
      isContinueDisabled: this.props.isContinueDisabled,
      showEnd: '',
      endMaxDate: moment(maxDate).add(-1, 'days'),
      startMaxDate: moment(maxDate).add(-1, 'days'),
      showhowManyEdgeMessage: false,
      endMinDate: moment().add(minEndDateDiffrence + 1, StringConstants.Days),
      formGroup: [],
      fieldBlurred: {
        amount: false,
        nextDue: false,
        endDate: false,
        reference: false,
      },
    };
  }
  componentWillMount() {
    this.setState({
      howMany: '',
    });
    this.setReccuringData();
    this.setHowOften();
  }
  componentDidMount() {}
  componentWillUnmount() {}
  setHowOften() {
    const key = Object.keys(
      this.props.activeData.scheduleData.recurrence.frequency
    );
    const value =
      this.props.activeData.scheduleData.recurrence.frequency[key].interval;
    const selectedValue = `${value} ${key[0]}`;
    if (selectedValue === 'NaN undefined') {
      this.setState({
        selectedValue: 'Every week',
      });
    } else {
      switch (selectedValue) {
        case '1 weekly':
          this.setState({
            selectedValue: this.props.content.Weekly,
          });
          break;
        case '2 weekly':
          this.setState({
            selectedValue: this.props.content.twoWeekly,
          });
          break;
        case '3 weekly':
          this.setState({
            selectedValue: this.props.content.threeWeekly,
          });
          break;
        case '4 weekly':
          this.setState({
            selectedValue: this.props.content.fourWeekly,
          });
          break;
        case '1 monthly':
          this.setState({
            selectedValue: this.props.content.monthly,
          });
          break;
        case '2 monthly':
          this.setState({
            selectedValue: this.props.content.twoMonthly,
          });
          break;
        case '3 monthly':
          this.setState({
            selectedValue: this.props.content.threeMonthly,
          });

          break;
        case '6 monthly':
          this.setState({
            selectedValue: this.props.content.sixMonthly,
          });
          break;
        case '12 monthly':
          this.setState({
            selectedValue: this.props.content.anually,
          });
          break;
      }
    }
  }
  setReccuringData() {
    const endCondition = this.props.activeData.scheduleData['end_condition'];
    if (endCondition) {
      if (endCondition.hasOwnProperty('when')) {
        this.state.selectedOption = '3';
        this.setState({
          showEnd: true,
          showHowMany: false,
          endWhen: moment(
            DateUtils.getMomentFromDateString(endCondition.when)
          ).format(config.dateFormatSlash),
        });

        const when = moment(
          DateUtils.getMomentFromDateString(endCondition.when)
        ).format(config.dateFormatSlash);
        const minStartDateDiffrence =
          DateUtils.comapareFromCurrentDateSlashFormat(when);
        this.setState({
          startMaxDate: moment().add(
            minStartDateDiffrence - 1,
            StringConstants.Days
          ),
        });
      } else {
        this.state.selectedOption = '2';
        this.setState({
          showEnd: false,
          showHowMany: true,
          howMany: endCondition.number_of_payments,
        });
      }
    } else {
      this.state.selectedOption = '1';
      this.setState({
        showEnd: false,
        showHowMany: false,
      });
    }
  }

  updateFormValidation(name, isValid, isChanged) {
    const formIndex = _.findIndex(this.state.formGroup, name);
    if (formIndex >= 0) {
      this.state.formGroup[formIndex][name] = {
        isValid,
        isChanged,
      };
    } else {
      const formElement = {};
      formElement[name] = {
        isValid,
        isChanged,
      };
      this.state.formGroup.push(formElement);
    }
    if (this.state.isContinueDisabled) {
      this.setState({ isContinueDisabled: false });
    }
  }
  checkOnBlurFeildValid(name) {
    const formIndex = _.findIndex(this.state.formGroup, name);
    if (formIndex >= 0) {
      if (!this.state.formGroup[formIndex][name].isValid) {
        this.showError(name, true);
      }
    }
  }
  onblur(e) {
    const name = e.target.name;
    this.state.fieldBlurred[name] = true;
    this.checkOnBlurFeildValid(name);
  }
  // to validate the amount
  amountChange(e) {
    const name = e.target.name;
    const value = e.target.value;
    const isInternalTransfer = this.props.activeData.isInternalPayment;
    // if previous value and changed value is same
    if (value === this.props.activeData.amount) {
      this.updateFormValidation(name, true, false);
      this.setState({
        amount: value,
      });
      return;
    }
    const validationResult = ValidationConfig.validateData(name, value);
    if (validationResult.isValid) {
      if (value.endsWith('.')) {
        this.setState({
          amount: value,
        });
        this.showError(name, true);
        this.updateFormValidation(name, false, true);
      } else if (value.length === 2 && value === '00') {
        this.showError(name, true);
        this.updateFormValidation(name, false, true);
      } else if (parseFloat(value) === 0.0) {
        this.setState({
          amount: value,
        });
        this.showError(name, true);
        this.updateFormValidation(name, false, true);
      } else if (
        !isInternalTransfer &&
        hasExceededYouthAccountPaymentLimit(value)
      ) {
        this.setState({
          amount: e.target.value,
        });
        this.showError(name, true);
        this.updateFormValidation(name, false, true);
        this.setState({ isContinueDisabled: true });
      } else if (value <= 999999) {
        this.setState({
          amount: value,
        });
        this.showError(name, false);
        this.updateFormValidation(name, true, true);
      }
    } else {
      if (!validationResult.regexValid) {
        const length = value.length;
        if (length === 0) {
          this.setState({
            amount: e.target.value,
          });
          this.showError(name, true);
          this.updateFormValidation(name, false, true);
        } else if (isNaN(value) && length === 1) {
          this.updateFormValidation(name, false, true);
        } else if (
          hasExceededYouthAccountPaymentLimit(value) ||
          value <= 999999
        ) {
          this.updateFormValidation(name, true, true);
        }
      } else if (!validationResult.minLengthValid) {
        this.setState({
          amount: e.target.value,
        });
        this.updateFormValidation(name, false, true);
        this.showError(name, true);
      } else if (!validationResult.maxLengthValid) {
        if (parseFloat(value) !== 0.0) {
          this.updateFormValidation(name, true, true);
        }
      }
    }
  }
  isGroupValid() {
    let isGroupValid = true;
    // todo global variable manipulation here!
    let isChangedCounter = 0; // eslint-disable-line
    _.every(this.state.formGroup, (item) => {
      const key = Object.keys(item)[0];
      if (item[key].isValid) {
        if (item[key].isChanged) {
          isChangedCounter++;
        }
      } else {
        this.refs[`${key}Component`].classList.toggle('c-field--error', true);
        isGroupValid = false;
        isChangedCounter = 1;
      }
      return true;
    });
    return isGroupValid;
  }
  editSOPayment() {
    let checkAllField = this.checkAllFields();
    if (checkAllField) {
      return;
    }

    if (
      this.isGroupValid() ||
      (!this.props.isContinueDisabled && this.state.formGroup.length === 0)
    ) {
      const activeData = _.cloneDeep(this.props.activeData);
      activeData.scheduleData.recurrence.frequency = {};
      if (!this.state.showEnd && !this.state.showHowMany) {
        delete activeData.scheduleData['end_condition'];
      } else {
        if (this.state.showEnd) {
          activeData.scheduleData.end_condition = {
            when: DateUtils.getAPIDateString(this.state.endWhen),
          };
        } else {
          activeData.scheduleData.end_condition = {
            number_of_payments: parseFloat(this.state.howMany),
          };
        }
      }
      activeData.reference = this.state.reference.trim();
      activeData.amount = parseFloat(this.state.amount);
      activeData.when = DateUtils.getAPIDateString(this.state.when);
      // added
      switch (this.state.selectedValue) {
        case 'Every week':
          activeData.scheduleData.recurrence.frequency['weekly'] = {
            interval: 1,
          };
          activeData.frequency = activeData.scheduleData.recurrence.frequency;
          break;
        case 'Every 2 weeks':
          activeData.scheduleData.recurrence.frequency['weekly'] = {
            interval: 2,
          };
          activeData.frequency = activeData.scheduleData.recurrence.frequency;
          break;
        case 'Every 3 weeks':
          activeData.scheduleData.recurrence.frequency['weekly'] = {
            interval: 3,
          };
          activeData.frequency = activeData.scheduleData.recurrence.frequency;
          break;
        case 'Every 4 weeks':
          activeData.scheduleData.recurrence.frequency['weekly'] = {
            interval: 4,
          };
          activeData.frequency = activeData.scheduleData.recurrence.frequency;
          break;
        case 'Every month':
          activeData.scheduleData.recurrence.frequency['monthly'] = {
            interval: 1,
          };
          activeData.frequency = activeData.scheduleData.recurrence.frequency;
          break;
        case 'Every 2 months':
          activeData.scheduleData.recurrence.frequency['monthly'] = {
            interval: 2,
          };
          activeData.frequency = activeData.scheduleData.recurrence.frequency;
          break;
        case 'Every 3 months':
          activeData.scheduleData.recurrence.frequency['monthly'] = {
            interval: 3,
          };
          activeData.frequency = activeData.scheduleData.recurrence.frequency;

          break;
        case 'Every 6 months':
          activeData.scheduleData.recurrence.frequency['monthly'] = {
            interval: 6,
          };
          activeData.frequency = activeData.scheduleData.recurrence.frequency;
          break;
        case 'Every year':
          activeData.scheduleData.recurrence.frequency['monthly'] = {
            interval: 12,
          };
          activeData.frequency = activeData.scheduleData.recurrence.frequency;
          break;
      }
      this.props.editSOPayment(activeData);
    } else {
      _.every(this.state.formGroup, (item) => {
        const key = Object.keys(item)[0];
        if (!item[key].isValid) {
          let inputType = this.refs[key];
          if (inputType) {
            if (key === 'endDate') inputType = inputType.refs['endDateInput'];
            inputType.focus();
            return false;
          }
        } else {
          return true;
        }
      });
    }
  }
  checkAllFields() {
    let fieldsValid = false;

    if (this.state.selectedOption === '2') {
      if (this.refs.howMany.value === '') {
        fieldsValid = true;
        this.state.fieldBlurred['noOfTimes'] = true; // added if user clicks on update changes without input
        this.showError('noOfTimes', true);
        this.refs.howMany.focus();
      }
    } else if (this.state.selectedOption === '3') {
      if (this.state.endWhen === undefined || this.state.endWhen === '') {
        fieldsValid = true;
        this.state.fieldBlurred['endDate'] = true; // added if user clicks on update changes without input
        this.refs['endDate'].refs['endDateInput'].focus();
        this.showError('endDate', true);
      }
    }
    if (this.refs.amount.value === '') {
      fieldsValid = true;
      this.state.fieldBlurred['amount'] = true; // added if user clicks on update changes without input
      this.showError('amount', true);
      this.refs.amount.focus();
      window.scrollTo(0, 0);
    }
    return fieldsValid;
  }
  repeatOptionChange(e) {
    const maxDate = moment().add(1, 'years');
    this.setState({
      startMaxDate: moment(maxDate).add(-1, 'days'),
    });
    switch (e.target.value) {
      case '1':
        this.setState({
          showEnd: false,
          showHowMany: false,
          howMany: '',
          endWhen: '',
        });
        //	const formIndex = _.findIndex(this.state.formGroup, 'howMany');
        _.remove(this.state.formGroup, 'noOfTimes');
        _.remove(this.state.formGroup, 'endDate');
        this.validateNextDue();
        //	this.state.formGroup.pop
        break;
      case '2':
        this.setState({
          showEnd: false,
          showHowMany: true,
          endWhen: '',
        });
        _.remove(this.state.formGroup, 'endDate');
        this.updateFormValidation('noOfTimes', false, false);
        break;
      case '3':
        this.setState({
          showEnd: true,
          showHowMany: false,
          howMany: '',
        });
        this.state.fieldBlurred['endDate'] = false;
        _.remove(this.state.formGroup, 'noOfTimes');
        this.updateFormValidation('endDate', false, false);
        this.validateNextDue();
    }
    this.setState({
      selectedOption: e.target.value,
    });
  }
  onNoOfTimesChange(e) {
    e.preventDefault();
    const name = e.target.name;
    const value = e.target.value;
    const validationResult = ValidationConfig.validateData(name, value);
    // If validation criteria is matched
    if (validationResult.isValid) {
      if (parseFloat(value) === 0.0) {
        this.setState({
          howMany: e.target.value,
        });
        this.updateFormValidation(name, true, true);
        this.setState({
          showhowManyEdgeMessage: false,
        });
        this.showError(name, true);
      } else if (value <= StringConstants.noOfTimesLimit) {
        this.updateFormValidation(name, true, true);
        this.showError(name, false);
      } else {
        this.updateFormValidation(name, false, true);
        if (!this.state.showhowManyEdgeMessage) {
          this.setState({
            showhowManyEdgeMessage: true,
          });
        }
        this.showError(name, true);
      }
      this.setState({
        howMany: e.target.value,
      });
    } else {
      if (!validationResult.regexValid) {
        if (value.length === 0) {
          this.setState({
            howMany: e.target.value,
          });
          this.updateFormValidation(name, false, true);
          this.setState({
            showhowManyEdgeMessage: false,
          });
          this.showError(name, true);
        }
      } else if (!validationResult.minLengthValid) {
        this.setState({
          howMany: e.target.value,
        });
        this.updateFormValidation(name, false, true);
        this.showError(name, true);
      }
    }
  }
  endDateBlur() {
    this.state.fieldBlurred['endDate'] = true;
    this.checkOnBlurFeildValid('endDate');
  }
  startDateBlur() {
    this.state.fieldBlurred['nextDue'] = true;
    this.checkOnBlurFeildValid('nextDue');
  }
  showEndDate() {
    const endData = this.state.showEnd ? (
      <div className="c-field c-field--datepicker" ref="endDateComponent">
        <label className="c-field__label c-field__label--block" htmlFor="fdp2">
          {StringConstants.stopPayment}
        </label>
        <div className="c-field__controls">
          <div className="c-field__append">
            <div className="pos-r">
              <DateTimeField
                ref="endDate"
                defaultText={this.state.endWhen || ''}
                dateTime={this.state.endWhen || DateUtils.getShortString1()}
                format={config.dateFormatSlash}
                inputFormat={config.dateFormatSlash}
                onChange={this.onEndDateChange}
                viewMode="days"
                minDate={this.state.endMinDate}
                maxDate={this.state.endMaxDate}
                inputProps={{
                  placeholder: config.dateFormatSlash,
                  id: 'fpd2',
                  ref: 'endDateInput',
                  onBlur: this.endDateBlur,
                  'aria-invalid': 'false',
                  'aria-label': 'Stop Payment',
                  'aria-required': 'true',
                }}
              />
            </div>
          </div>
          <div
            className="c-field__message"
            ref="endDateMessage"
            id="endMsgErr"
            role="alert"
          >
            <p>{ValidationMessageConstants.endDateErrorMessage}</p>
          </div>
        </div>
      </div>
    ) : null;
    return endData;
  }
  showHowMany() {
    const data = this.state.showHowMany ? (
      <div className="c-field" ref="noOfTimesComponent">
        <label className="c-field__label c-field__label--block" htmlFor="f1">
          {StringConstants.noOfPayments}
        </label>
        <div className="c-field__controls">
          <input
            aria-invalid="false"
            aria-required="true"
            className="c-field__input"
            type="text"
            name="noOfTimes"
            ref="howMany"
            id="f1"
            value={this.state.howMany}
            onChange={this.onNoOfTimesChange}
            onBlur={this.onblur}
          />
          <div
            className="c-field__message"
            ref="howManyMessage"
            role="alert"
            id="howManyErr"
          >
            <p>
              {this.state.showhowManyEdgeMessage
                ? ValidationMessageConstants.noOfTimesEdgeCaseMessage
                : ValidationMessageConstants.noOfTimesErrorMessage}
            </p>
          </div>
        </div>
      </div>
    ) : null;
    return data;
  }
  validateNextDue() {
    const validationResult = ValidationConfig.validateDate(this.state.when);
    this.updateFormValidation('nextDue', validationResult, true);
    if (validationResult) {
      this.showError('nextDue', !validationResult);
    }
  }
  onNextDueChange(e) {
    const validationResult = ValidationConfig.validateDate(e);
    let dateDifference = 0;
    if (!validationResult) {
      this.showError('nextDue', true);
      this.updateFormValidation('nextDue', validationResult, true);
    } else {
      let dateIsLessThan = true;
      if (
        this.state.endWhen &&
        ValidationConfig.validateDate(this.state.endWhen)
      ) {
        dateIsLessThan = ValidationConfig.isBefore(e, this.state.endWhen);
      } else {
        dateIsLessThan = ValidationConfig.isBefore(e, moment().add(1, 'years'));
      }
      const isGretaterThanCurrentDate = ValidationConfig.isAfter(e, moment());
      if (dateIsLessThan && isGretaterThanCurrentDate) {
        this.showError('nextDue', false);
        this.updateFormValidation('nextDue', true, true);
        dateDifference = DateUtils.comapareFromCurrentDateSlashFormat(e);
      } else {
        this.showError('nextDue', true);
        this.updateFormValidation('nextDue', false, true);
      }
    }
    this.setState({
      when: e,
      endMinDate: moment().add(dateDifference + 1, StringConstants.Days),
    });
  }
  onEndDateChange(e) {
    const validationResult = ValidationConfig.validateDate(e);
    this.updateFormValidation('endDate', validationResult, true);
    if (validationResult) {
      let isGretaterThanCurrentDate = true;
      const dateIsLessThan = ValidationConfig.isBefore(
        e,
        moment().add(1, 'years')
      );
      const validationResult = ValidationConfig.validateDate(this.state.when);
      if (validationResult) {
        isGretaterThanCurrentDate = ValidationConfig.isAfter(
          e,
          this.state.when
        );
      } else {
        const date = new Date();
        date.setDate(date.getDate() - 1);
        isGretaterThanCurrentDate = ValidationConfig.isAfter(e, date);
      }
      if (isGretaterThanCurrentDate && dateIsLessThan) {
        const difference = DateUtils.comapareFromCurrentDateSlashFormat(e);
        this.setState({
          startMaxDate: moment().add(difference - 1, StringConstants.Days),
        });
        this.updateFormValidation('endDate', true, true);
        this.showError('endDate', false);
      } else {
        this.updateFormValidation('endDate', false, true);
        this.showError('endDate', true);
      }
    } else {
      this.updateFormValidation('endDate', false, true);
      this.showError('endDate', true);
    }
    this.setState({
      endWhen: e,
    });
  }
  showError(name, show) {
    if (this.refs[`${name}Component`] && this.state.fieldBlurred[name]) {
      if (show) {
        this.refs[`${name}Component`].classList.add('c-field--error');
      } else {
        this.refs[`${name}Component`].classList.remove('c-field--error');
      }
    }
  }

  referenceChange(e) {
    const name = e.target.name;
    const value = e.target.value;
    const expression = RegexUtils.regexes.referenceRegex;
    const actualValue = value.match(expression)[0];
    if (this.props.activeData.payType === 'Payment') {
      if (actualValue.trim().length === 0) {
        this.updateFormValidation(name, false, true);
        this.showError(name, true);
      } else {
        this.updateFormValidation(name, true, true);
        this.showError(name, false);
      }
    } else {
      this.updateFormValidation(e.target.name, true, true);
    }
    this.setState({
      reference: actualValue,
    });
  }
  onRefBlur(e) {
    const name = e.target.name;
    if (this.props.activeData.payType === 'Payment') {
      this.state.fieldBlurred[name] = true;
      this.checkOnBlurFeildValid(name);
    }
    this.setState({
      reference: e.target.value.trim(),
    });
    // TO DO Check weather it is valid or not if no Show error message
  }

  oftenChange(e) {
    // const selectedHowOften = FrequencyUtils.getFrequencyValue(e);
    // this.state.howOftenKey = e;
    // this.setState({
    //     selectedHowOften,
    // });
    switch (e) {
      case 'weekly':
        this.setState({
          selectedValue: this.props.content.Weekly,
        });
        break;
      case '2 weekly':
        this.setState({
          selectedValue: this.props.content.twoWeekly,
        });
        break;
      case '3 weekly':
        this.setState({
          selectedValue: this.props.content.threeWeekly,
        });
        break;
      case '4 weekly':
        this.setState({
          selectedValue: this.props.content.fourWeekly,
        });
        break;
      case '1 monthly':
        this.setState({
          selectedValue: this.props.content.monthly,
        });
        break;
      case '2 monthly':
        this.setState({
          selectedValue: this.props.content.twoMonthly,
        });
        break;
      case '3 monthly':
        this.setState({
          selectedValue: this.props.content.threeMonthly,
        });

        break;
      case '6 monthly':
        this.setState({
          selectedValue: this.props.content.sixMonthly,
        });
        break;
      case '12 monthly':
        this.setState({
          selectedValue: this.props.content.anually,
        });
        break;
    }
    this.updateFormValidation('howOften', true, true);
  }
  render() {
    const { isSMEUser } = this.props;
    return (
      <div>
        <div className="c-field" ref="amountComponent">
          <label
            className="c-field__label c-field__label--block"
            htmlFor="fapp1"
          >
            Amount
          </label>
          <div className="c-field__controls">
            <div className="c-field__prepend">
              <span className="c-field__addon">&pound;</span>
              <input
                aria-label="Amount in pounds and pence"
                aria-invalid="false"
                aria-required="true"
                className="c-field__input"
                type="text"
                name="amount"
                ref="amount"
                id="fapp1"
                value={this.state.amount}
                onChange={this.amountChange}
                onBlur={this.onblur}
              />
            </div>
            <div
              className="c-field__message"
              ref="amountMessage"
              id="amountErr"
              role="alert"
            >
              <p>
                {hasExceededYouthAccountPaymentLimit(this.state.amount)
                  ? this.props.content.youthAccountAmountExceededMessage
                  : this.props.content.amountErrorMessage}
              </p>
            </div>
          </div>
        </div>
        <div className="c-field c-field--disabled" ref="referenceComponent">
          <label
            className="c-field__label c-field__label--black c-field__label--block"
            htmlFor="f2"
          >
            {this.props.content.reference}
            {this.props.activeData.payType === 'Transfer' ? (
              <span className="c-field__option"> (optional)</span>
            ) : null}
          </label>
          <div className="c-field__controls">
            <input
              ref="reference"
              aria-invalid="false"
              aria-required="true"
              className="c-field__input"
              value={this.state.reference}
              type="text"
              name="reference"
              id="f2"
              onChange={this.referenceChange}
              onBlur={this.onRefBlur}
              disabled
            />
            <div
              className="c-field__message"
              ref="referenceMessage"
              id="referenceErr"
              role="alert"
            >
              <p>{this.props.content.refErrorMsgManagePayments}</p>
            </div>
          </div>
        </div>
        <div className="c-field editso__frequency">
          <label
            id="repeatPayment"
            className="c-field__label field__label--block"
            htmlFor="d002"
          >
            {this.props.content.howOften}
          </label>
          <div className="c-field__controls">
            <div className="btn-toolbar">
              <Dropdown id="d002" name="howOften" className="custom-dropdown">
                <Dropdown.Toggle
                  noCaret
                  aria-labelledby="repeatPayment selectedValue"
                >
                  <span id="selectedValue" className="btn--title">
                    {this.state.selectedValue}
                  </span>
                  <span className="symbol">
                    <svg width="32" height="32" viewBox="0 0 32 32">
                      <path d="M19.55 12.602l1.884 1.833-5.717 5.565-5.717-5.565 1.883-1.833 3.833 3.731z" />
                    </svg>
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <MenuItem eventKey="weekly" onSelect={this.oftenChange}>
                    {this.props.content.Weekly}
                  </MenuItem>
                  <MenuItem eventKey="2 weekly" onSelect={this.oftenChange}>
                    {this.props.content.twoWeekly}
                  </MenuItem>
                  <MenuItem eventKey="3 weekly" onSelect={this.oftenChange}>
                    {this.props.content.threeWeekly}
                  </MenuItem>
                  <MenuItem eventKey="4 weekly" onSelect={this.oftenChange}>
                    {this.props.content.fourWeekly}
                  </MenuItem>
                  <MenuItem eventKey="1 monthly" onSelect={this.oftenChange}>
                    {this.props.content.monthly}
                  </MenuItem>
                  <MenuItem eventKey="2 monthly" onSelect={this.oftenChange}>
                    {this.props.content.twoMonthly}
                  </MenuItem>
                  <MenuItem eventKey="3 monthly" onSelect={this.oftenChange}>
                    {this.props.content.threeMonthly}
                  </MenuItem>
                  <MenuItem eventKey="6 monthly" onSelect={this.oftenChange}>
                    {this.props.content.sixMonthly}
                  </MenuItem>
                  <MenuItem eventKey="12 monthly" onSelect={this.oftenChange}>
                    {this.props.content.anually}
                  </MenuItem>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>
        <div className="c-field c-field--datepicker" ref="nextDueComponent">
          <label
            className="c-field__label c-field__label--block"
            htmlFor="fdp1"
          >
            {StringConstants.nextPayment}
          </label>
          <div className="c-field__controls">
            <div className="c-field__append">
              <div className="pos-r">
                <DateTimeField
                  defaultText={this.state.when || ''}
                  dateTime={this.state.when || DateUtils.getShortString1()}
                  format={config.dateFormatSlash}
                  inputFormat={config.dateFormatSlash}
                  onChange={this.onNextDueChange}
                  viewMode="days"
                  minDate={moment().add(1, 'days')}
                  maxDate={this.state.startMaxDate}
                  inputProps={{
                    title: `${config.dateFormatSlash}`,
                    placeholder: config.dateFormatSlash,
                    id: 'fdp1',
                    onBlur: this.startDateBlur,
                    ref: 'nextDueInput',
                    'aria-required': 'true',
                    'aria-invalid': 'false',
                  }}
                />
              </div>
            </div>
            <div
              className="c-field__message "
              ref="amountMessage"
              role="alert"
              id="nextAmountErr"
            >
              <p>{this.props.content.nextDateErrorMessage}</p>
            </div>
          </div>
        </div>
        <div className="c-field c-field--radios c-field--radios--with-border">
          <label
            className="c-field__label field__label--block"
            htmlFor="irb001"
          >
            <span id="frequency_stop">{StringConstants.stopPayment}</span>
          </label>
          <div className="c-field__controls">
            <div className="c-radio">
              <RadioButton
                aria-labelledby="frequency_stop frequency_stop_type1"
                name="irbyn"
                value="1"
                ref="irb001"
                id="irb001"
                onClick={this.repeatOptionChange}
                className="c-radio__inline"
                checked={this.state.selectedOption === '1'}
                inline
              >
                <label
                  id="frequency_stop_type1"
                  htmlFor="irb001"
                  className="c-radio__label c-radio__label--border"
                >
                  <span id="frequency_stop">
                    {this.props.content.whenIcancel}
                  </span>
                </label>
              </RadioButton>

              <RadioButton
                aria-labelledby="frequency_stop frequency_stop_type2"
                className="c-radio__inline"
                value="2"
                name="irbyn"
                ref="irb002"
                id="irb002"
                onClick={this.repeatOptionChange}
                checked={this.state.selectedOption === '2'}
                inline
              >
                <label
                  id="frequency_stop_type2"
                  htmlFor="irb002"
                  className="c-radio__label c-radio__label--border"
                >
                  {/* <div className="radiobutton__circle"></div>
                                        <p className="text type--jura">{this.props.content.noOfTimes}</p>*/}
                  {this.props.content.noOfTimes}
                </label>
              </RadioButton>

              <RadioButton
                aria-labelledby="frequency_stop frequency_stop_type3"
                className="c-radio__inline"
                value="3"
                name="irbyn"
                ref="irb003"
                id="irb003"
                onClick={this.repeatOptionChange}
                checked={this.state.selectedOption === '3'}
                inline
              >
                <label
                  id="frequency_stop_type3"
                  htmlFor="irb003"
                  className="c-radio__label c-radio__label--border"
                >
                  {/* <div className="radiobutton__circle"></div>
                                        <p className="text type--jura">{this.props.content.pickdate}</p>*/}
                  {this.props.content.pickdate}
                </label>
              </RadioButton>
            </div>
          </div>
        </div>
        {this.showEndDate()}
        {this.showHowMany()}
        <div className="c-field">
          <button
            onClick={this.props.goBack}
            className="c-btn c-btn--secondary"
          >
            {StringConstants.back}
          </button>
          &nbsp;
          <button
            className="c-btn c-btn--default"
            disabled={this.state.isContinueDisabled}
            onClick={this.editSOPayment}
          >
            {isSMEUser
              ? StringConstants.continue
              : StringConstants.confirmChanges}
          </button>
        </div>
      </div>
    );
  }
}
EditSOPayment.propTypes = {
  content: PropTypes.object,
  isSMEUser: PropTypes.bool.isRequired,
};
export default EditSOPayment;
